import styled from 'styled-components';
import { radius } from '@/styles/Themes/Metrics';
import Palette from '@/styles/Themes/Palette';
import { cssVars } from '@/styles/Themes/cssVars';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';

export const PublicationsSection = styled.section`
    border-radius: ${radius.small};
    padding: 32px;
    background-color: ${cssVars.bg_sand_dark3};
`;

export const Title = styled.h3`
    ${Text.Full.heading2}
    color: ${cssVars.fg_gray1_white};
    margin-bottom: 2rem;
    padding-left: 1rem;
`;

export const Grid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0 auto;

    ${Screen.desktop} {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
        gap: 24px;
    }
`;

export const Card = styled.div`
    display: flex;
    align-items: center;
    background: white;
    padding: 12px;
    border-radius: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s ease;
    background-color: ${cssVars.bg_white_darker_07};

    &:hover {
        transform: translateY(-2px);
    }
`;

export const LogoWrapper = styled.div`
    width: 60px;
    height: 60px;
    flex-shrink: 0;
    margin-right: 1rem;
    position: relative;
    background-color: ${cssVars.bg_gray4_dark1};
    padding: 14px;
    border-radius: 16px;
`;

export const Content = styled.div`
    flex: 1;
`;

export const PublicationTitle = styled.h3`
    ${Text.Full.heading4}
    color: ${cssVars.fg_gray1_white};
    margin: 0 0 0.5rem 0;
`;

export const LearnMore = styled.a`
    ${Text.Full.large.medium};
    color: ${Palette.green.normal};
    text-decoration: none;
    display: inline-flex;
    align-items: baseline;

    &:hover {
        text-decoration: underline;
    }

    &::after {
        content: '›';
        margin-left: 4px;
        font-size: 20px;
    }
`;

export const LogoImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;
`;
